import React from 'react';
import MModal from 'assets/js/modal';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ModalHeader = React.forwardRef(({ scrollable, className, children, defaults, defaultFont, exitButton, exitButtonClick, noShadow, ...rest }, ref) => {
    const classNames = classnames({
        [className]: className,
        "default-modal-header-font": defaultFont,
        "default-modal-header": defaults,
        "scroll-modal-header": scrollable,
        "no-shadow": noShadow
    })
    return (
        <div className={classNames} ref={ref} {...rest}>
            {children}
            {exitButton && (<div className="modal-close low-opacity-icon modal-close-btn" onClick={exitButtonClick}><FontAwesomeIcon icon="times" /></div>)}
        </div>
    )
})

export const ModalFooter = React.forwardRef(({ scrollable, className, children, defaults, noShadow }, ref) => {
    const classNames = classnames({
        [className]: className,
        "default-modal-footer": defaults,
        "scroll-modal-footer": scrollable,
        "no-shadow": noShadow
    })
    return (
        <div className={classNames} ref={ref}>
            {children}
        </div>
    )
})

export class BasicModal extends React.PureComponent {

    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
        this.onClick = this.onClick.bind(this);
        this.onOpenStart = this.onOpenStart.bind(this);
        this.onCloseEnd = this.onCloseEnd.bind(this);
        this.state = { open: false };
    }

    componentDidMount() {
        this.modal = MModal.init(this.modalRef.current, {...this.props.options, onOpenStart: this.onOpenStart, onCloseEnd: this.onCloseEnd });
        if(this.props.startOpen) {
            this.modal.open();
        }
    }

    render() {
        const { fullWidth, className } = this.props;
        const classNames = classnames({"modal": true, "full-width": fullWidth, [className]: className });
        return (
            <React.Fragment>
                {this.props.triggerRender({ onClick: this.onClick })}
                <div className={classNames} ref={this.modalRef}>
                    {this.state.open && this.props.contentRender()}
                </div>
            </React.Fragment>
        )
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.modal.close();
    }

    onOpenStart() {
        if(!this.unmounted)
            this.setState( {open: true} );
    }

    onCloseEnd() {
        if(this.unmounted)
            this.modal.destroy();
        else
            this.setState( {open: false} );
    }

    onClick() {
        if(!this.state.open) {
            this.modal.open();
        }
    }

}
